import Section from "../section";

export default class Event extends Section {
  constructor(calculator) {
    super(calculator);

    this.form.find('.catcalc-event-guests input,' +
      '.catcalc-event-wedding input,' +
       '.catcalc-foodservice-style input,' +
      '.catcalc-foodservice-dishes input').on('change', ()=> this.form.trigger('catcalc.change'));

    this.form.find('.catcalc-event-wedding input').on('change', () => this.form.trigger('catcalc.change.wedding'));

    this.form.find('.catcalc-foodservice-style input').on('change', (e) => {
          let $t = $(e.target);
          switch($t.val().toLowerCase()) {
            case 'family style':
            case 'plated':
              this.form.find('.catcalc-foodservice-dishes input[value="Real Dishware"]').attr('checked', true);
              this.form.find('.catcalc-foodservice-dishes input:not(:checked)').attr('disabled', true);
              break;
            case 'buffet':
              this.form.find('.catcalc-foodservice-dishes input').attr('disabled', false);
          }
        });

    this.form.find('.catcalc-event-duration input').on('change', (e) => {
        let $t = $(e.target);
        let $tooltip = $t.parent('.ginput_container').find('.noUi-handle .noUi-tooltip');

        if(!$tooltip.text().includes('hour')) {
          $tooltip.append(($t.val() > 1)? ' hours':' hour');
        }
    }).trigger('change');

  }

  get name() {
    let field = this.form.find('.catcalc-event-name input')
    if( field.length ){
      return field.val()
    }
  }

  get duration() {
    let field = this.form.find('.catcalc-event-duration input')
    if (field.length) {
      return field.val()
    }
  }

  get guests() {
    let field = this.form.find('.catcalc-event-guests input')
    if (field.length) {
      return field.val()
    }
  }

  get wedding() {
    let field = this.form.find('.catcalc-event-wedding input:checked')
    if (field.length) {
      return field.val().toLowerCase()
    }
  }

  get style() {
    let field = this.form.find('.catcalc-foodservice-style input:checked')
    if (field.length) {
      return field.val().toLowerCase()
    }
  }

  get dishes() {
    let field = this.form.find('.catcalc-foodservice-dishes input:checked')
    if (field.length) {
      return field.val().toLowerCase()
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/catcalc/sections/event.js